import React, { useState, useEffect } from 'react';
import './App.css';
import HomePage from './HomePage';
import LandingBasic from './LandingBasic';
// import Option1 from './Option1'; // Hidden - Option2 is now the main landing
import LandingExpert from './LandingExpert';
import Option2 from './Option2';
import DemoVideo from './DemoVideo';
import ClientSoeasi from './ClientSoeasi';
import InscriptionPage from './InscriptionPage';
import BilanPatrimonial from './BilanPatrimonial';
import SOeasiSimulator from './SOeasiSimulator';
import AMFRiskProfiler from './AMFRiskProfiler';
import AssistantIA from './AssistantIA';
import MonComptePage from './MonComptePage';
import SimulateurInvestissement from './SimulateurInvestissement';
import SimulateurProduits from './SimulateurProduits';
import SimulateurStrategies from './SimulateurStrategies';
import SimulateurBesoins from './SimulateurBesoins';
import SimulateurProfilRisque from './SimulateurProfilRisque';
import GuidedInvestment from './GuidedInvestment';
import NosSimulateurs from './NosSimulateurs';
import ProduitsExplication from './ProduitsExplication';
import GuidedTour from './components/GuidedTour';
import ContextualAssistant from './components/ContextualAssistant';
import GuidancePopup from './components/GuidancePopup';
import { RobotIcon } from './components/icons/RobotIcon';
import { XMarkIcon } from './components/icons/XMarkIcon';

type CurrentStep = 'home' | 'homepage-old' | 'landing-basic' | 'landing-expert' | 'option1' | 'option2' | 'demo-video' | 'client-soeasi' | 'inscription' | 'soeasi' | 'risk-profiling' | 'simulateur-profil-risque' | 'bilan' | 'mon-compte' | 'simulateur-investissement' | 'simulateur-produits' | 'simulateur-strategies' | 'simulateur-besoins' | 'guided-investment' | 'nos-simulateurs' | 'produits-explication';

interface ClassicAppProps {
  onOpenChat: () => void;
  onStartTour: (tourType: 'homepage' | 'simulator-investment' | 'simulator-products' | 'simulator-strategies' | 'simulator-needs') => void;
  navigationRequest?: 'products' | 'strategies' | 'needs' | null;
  onNavigationComplete: () => void;
}

const ClassicApp: React.FC<ClassicAppProps> = ({ onOpenChat, onStartTour, navigationRequest, onNavigationComplete }) => {
  const [currentStep, setCurrentStep] = useState<CurrentStep>('home');
  const [userProfileData, setUserProfileData] = useState<any>(null);

  useEffect(() => {
    if (navigationRequest) {
      if (navigationRequest === 'products') {
        setCurrentStep('simulateur-produits');
      } else if (navigationRequest === 'strategies') {
        setCurrentStep('simulateur-strategies');
      } else if (navigationRequest === 'needs') {
        setCurrentStep('simulateur-besoins');
      }
      onNavigationComplete();
    }
  }, [navigationRequest, onNavigationComplete]);
  
  const handleSOeasiComplete = (profileData: any) => {
    setUserProfileData(profileData);
    setCurrentStep('bilan');
  };

  const handleRiskProfilingComplete = (riskData: any) => {
    console.log('Risk profiling completed:', riskData);
    setCurrentStep('bilan');
  };

  const handleStartSimulator = () => {
    setCurrentStep('soeasi');
  };

  const handleStartChat = () => {
    onOpenChat();
  };

  const handleStartInscription = () => {
    setCurrentStep('inscription');
  };

  const handleOpenMonCompte = () => {
    setCurrentStep('mon-compte');
  };

  const handleStartSimulateurInvestissement = () => {
    setCurrentStep('simulateur-investissement');
  };

  const handleStartSimulateurProduits = () => {
    setCurrentStep('simulateur-produits');
  };

  const handleStartSimulateurStrategies = () => {
    setCurrentStep('simulateur-strategies');
  };

  const handleStartSimulateurBesoins = () => {
    setCurrentStep('simulateur-besoins');
  };

  const handleStartGuidedInvestment = () => {
    setCurrentStep('guided-investment');
  };

  const handleStartNosSimulateurs = () => {
    setCurrentStep('nos-simulateurs');
  };

  const handleStartProduitsExplication = () => {
    setCurrentStep('produits-explication');
  };

  const handleStartProfilRisque = () => {
    setCurrentStep('simulateur-profil-risque');
  };

  const handleNavigateLandingBasic = () => {
    setCurrentStep('landing-basic');
  };

  const handleNavigateLandingExpert = () => {
    setCurrentStep('landing-expert');
  };

  // Option1 navigation is now hidden
  // const handleNavigateOption1 = () => {
  //   setCurrentStep('option1');
  // };

  const handleNavigateOption2 = () => {
    setCurrentStep('option2');
  };

  const handleNavigateClientSoeasi = () => {
    setCurrentStep('client-soeasi');
  };

  const handleNavigateDemoVideo = () => {
    setCurrentStep('demo-video');
  };

  const handleProfilRisqueComplete = (results: any) => {
    console.log('Profil risque completed:', results);
    setUserProfileData(results);
    setCurrentStep('simulateur-produits');
  };

  if (currentStep === 'home') {
    return <Option2 onNavigateBack={() => setCurrentStep('homepage-old')} onStartSimulator={handleStartProduitsExplication} onStartInscription={handleStartInscription} onOpenMonCompte={handleOpenMonCompte} onStartChat={handleStartChat} onStartProfilRisque={handleStartProfilRisque} onStartSimulateurProduits={handleStartSimulateurProduits} />;
  }

  if (currentStep === 'homepage-old') {
    return <HomePage onStartSimulator={handleStartSimulator} onStartChat={handleStartChat} onStartInscription={handleStartInscription} onOpenMonCompte={handleOpenMonCompte} onStartSimulateurInvestissement={handleStartSimulateurInvestissement} onStartSimulateurProduits={handleStartSimulateurProduits} onStartSimulateurStrategies={handleStartSimulateurStrategies} onStartSimulateurBesoins={handleStartSimulateurBesoins} onStartGuidedInvestment={handleStartGuidedInvestment} onStartNosSimulateurs={handleStartNosSimulateurs} onStartProfilRisque={handleStartProfilRisque} onStartTour={onStartTour} onNavigateLandingBasic={handleNavigateLandingBasic} onNavigateLandingExpert={handleNavigateLandingExpert} onNavigateOption1={undefined} onNavigateOption2={handleNavigateOption2} onNavigateClientSoeasi={handleNavigateClientSoeasi} onStartProduitsExplication={handleStartProduitsExplication} />;
  }

  if (currentStep === 'landing-basic') {
    return <LandingBasic onNavigateBack={() => setCurrentStep('home')} onStartSimulator={handleStartSimulator} onStartInscription={handleStartInscription} onOpenMonCompte={handleOpenMonCompte} onStartProfilRisque={handleStartProfilRisque} />;
  }

  if (currentStep === 'landing-expert') {
    return <LandingExpert onNavigateBack={() => setCurrentStep('home')} onStartSimulator={handleStartSimulator} onStartInscription={handleStartInscription} onOpenMonCompte={handleOpenMonCompte} onStartChat={handleStartChat} />;
  }

  // Option1 is now hidden
  // if (currentStep === 'option1') {
  //   return <Option1 onNavigateBack={() => setCurrentStep('home')} onStartSimulator={handleStartSimulator} onStartInscription={handleStartInscription} onOpenMonCompte={handleOpenMonCompte} onStartProfilRisque={handleStartProfilRisque} onNavigateDemoVideo={handleNavigateDemoVideo} />;
  // }

  if (currentStep === 'option2') {
    return <Option2 onNavigateBack={() => setCurrentStep('home')} onStartSimulator={handleStartProduitsExplication} onStartInscription={handleStartInscription} onOpenMonCompte={handleOpenMonCompte} onStartChat={handleStartChat} onStartProfilRisque={handleStartProfilRisque} onStartSimulateurProduits={handleStartSimulateurProduits} />;
  }

  if (currentStep === 'demo-video') {
    return <DemoVideo onNavigateBack={() => setCurrentStep('option1')} onStartProfilRisque={handleStartProfilRisque} />;
  }

  if (currentStep === 'client-soeasi') {
    return <ClientSoeasi onNavigateBack={() => setCurrentStep('home')} onStartSimulator={handleStartSimulator} onStartInscription={handleStartInscription} onOpenMonCompte={handleOpenMonCompte} onStartChat={handleStartChat} />;
  }

  if (currentStep === 'mon-compte') {
    return <MonComptePage onNavigateBack={() => setCurrentStep('home')} />;
  }

  if (currentStep === 'inscription') {
    return <InscriptionPage onNavigateBack={() => setCurrentStep('home')} />;
  }

  if (currentStep === 'soeasi') {
    return (
      <div className="soeasi-container">
        <div className="flex items-center justify-between p-4 bg-white border-b border-gray-200">
          <button
            onClick={() => setCurrentStep('home')}
            className="flex items-center space-x-2 text-gray-600 hover:text-teal-600 transition-colors"
          >
            <span>←</span>
            <span>Retour à l'accueil</span>
          </button>
        </div>
        <SOeasiSimulator onStartBilanComplete={handleSOeasiComplete} onCompleteProfile={handleSOeasiComplete} />
      </div>
    );
  }

  if (currentStep === 'risk-profiling') {
    return (
      <div className="app-container">
        <AMFRiskProfiler 
          onComplete={handleRiskProfilingComplete}
          onNavigateBack={() => setCurrentStep('soeasi')}
        />
      </div>
    );
  }

  if (currentStep === 'simulateur-investissement') {
    return (
      <div className="app-container">
        <div className="flex items-center justify-between p-4 bg-white border-b border-gray-200">
          <button
            onClick={() => setCurrentStep('home')}
            className="flex items-center space-x-2 text-gray-600 hover:text-teal-600 transition-colors"
          >
            <span>←</span>
            <span>Retour à l'accueil</span>
          </button>
        </div>
        <SimulateurInvestissement />
      </div>
    );
  }

  if (currentStep === 'simulateur-produits') {
    return (
      <div className="app-container">
        <div className="flex items-center justify-between p-4 bg-white border-b border-gray-200">
          <button
            onClick={() => setCurrentStep('home')}
            className="flex items-center space-x-2 text-gray-600 hover:text-teal-600 transition-colors"
          >
            <span>←</span>
            <span>Retour à l'accueil</span>
          </button>
        </div>
        <SimulateurProduits />
      </div>
    );
  }

  if (currentStep === 'simulateur-strategies') {
    return (
      <div className="app-container">
        <div className="flex items-center justify-between p-4 bg-white border-b border-gray-200">
          <button
            onClick={() => setCurrentStep('home')}
            className="flex items-center space-x-2 text-gray-600 hover:text-teal-600 transition-colors"
          >
            <span>←</span>
            <span>Retour à l'accueil</span>
          </button>
        </div>
        <SimulateurStrategies />
      </div>
    );
  }

  if (currentStep === 'simulateur-besoins') {
    return (
      <div className="app-container">
        <div className="flex items-center justify-between p-4 bg-white border-b border-gray-200">
          <button
            onClick={() => setCurrentStep('home')}
            className="flex items-center space-x-2 text-gray-600 hover:text-teal-600 transition-colors"
          >
            <span>←</span>
            <span>Retour à l'accueil</span>
          </button>
        </div>
        <SimulateurBesoins />
      </div>
    );
  }

  if (currentStep === 'guided-investment') {
    return <GuidedInvestment onNavigateBack={() => setCurrentStep('home')} />;
  }

  if (currentStep === 'simulateur-profil-risque') {
    return <SimulateurProfilRisque 
      onNavigateBack={() => setCurrentStep('home')} 
      onComplete={handleProfilRisqueComplete}
    />;
  }

  if (currentStep === 'nos-simulateurs') {
    return <NosSimulateurs
      onNavigateBack={() => setCurrentStep('home')}
      onStartSimulateurStrategies={handleStartSimulateurStrategies}
      onStartSimulator={handleStartSimulator}
      onStartGuidedInvestment={handleStartGuidedInvestment}
      onStartSimulateurInvestissement={handleStartSimulateurInvestissement}
    />;
  }

  if (currentStep === 'produits-explication') {
    return <ProduitsExplication
      onNavigateBack={() => setCurrentStep('home')}
      onStartSimulator={handleStartSimulator}
    />;
  }

  return (
    <div className="app-container">
      <div className="flex items-center justify-between p-4 bg-white border-b border-gray-200">
        <button
          onClick={() => setCurrentStep('home')}
          className="flex items-center space-x-2 text-gray-600 hover:text-teal-600 transition-colors"
        >
          <span>←</span>
          <span>Retour à l'accueil</span>
        </button>
      </div>
      <div className="app-layout">
        <BilanPatrimonial 
          onNavigateToSOeasi={() => setCurrentStep('soeasi')} 
          userProfileData={userProfileData}
        />
      </div>
    </div>
  );
};

const App: React.FC = () => {
  const [isChatOpen, setIsChatOpen] = useState<boolean>(false);
  const [showGuidancePopup, setShowGuidancePopup] = useState<boolean>(false);
  const [navigationRequest, setNavigationRequest] = useState<'products' | 'strategies' | 'needs' | null>(null);
  const [guidedTour, setGuidedTour] = useState<{
    isActive: boolean;
    tourType: 'homepage' | 'simulator-investment' | 'simulator-products' | 'simulator-strategies' | 'simulator-needs';
  }>({
    isActive: false,
    tourType: 'homepage'
  });

  const handleOpenChat = () => {
    setIsChatOpen(true);
  };

  const handleStartTour = (tourType: 'homepage' | 'simulator-investment' | 'simulator-products' | 'simulator-strategies' | 'simulator-needs') => {
    setGuidedTour({
      isActive: true,
      tourType
    });
  };

  const handleCompleteTour = () => {
    setGuidedTour(prev => ({ ...prev, isActive: false }));
  };

  const handleSkipTour = () => {
    setGuidedTour(prev => ({ ...prev, isActive: false }));
  };

  const handleCloseGuidancePopup = () => {
    setShowGuidancePopup(false);
    // Marquer que l'utilisateur a vu la guidance
    localStorage.setItem('soeasi_guidance_seen', 'true');
  };

  const handleStartProductSimulation = () => {
    setShowGuidancePopup(false);
    localStorage.setItem('soeasi_guidance_seen', 'true');
    setNavigationRequest('products');
  };

  const handleStartStrategySimulation = () => {
    setShowGuidancePopup(false);
    localStorage.setItem('soeasi_guidance_seen', 'true');
    setNavigationRequest('strategies');
  };

  const handleStartNeedsAnalysis = () => {
    setShowGuidancePopup(false);
    localStorage.setItem('soeasi_guidance_seen', 'true');
    setNavigationRequest('needs');
  };

  const handleNavigationComplete = () => {
    setNavigationRequest(null);
  };

  return (
    <div className="relative min-h-screen">
      <ClassicApp 
        onOpenChat={handleOpenChat} 
        onStartTour={handleStartTour}
        navigationRequest={navigationRequest}
        onNavigationComplete={handleNavigationComplete}
      />

      {/* Fenêtre de Chat (modale) */}
      <div className={`fixed bottom-0 right-0 sm:bottom-8 sm:right-8 w-full h-full sm:w-[400px] sm:h-[70vh] sm:max-h-[700px] z-50 transition-transform duration-300 ease-in-out ${isChatOpen ? 'transform translate-y-0' : 'transform translate-y-full sm:translate-y-0 sm:opacity-0 sm:pointer-events-none'}`}>
        <div className="bg-white rounded-t-lg sm:rounded-2xl shadow-2xl border border-gray-200 flex flex-col w-full h-full">
          <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-gray-50 rounded-t-lg sm:rounded-t-2xl flex-shrink-0">
            <h2 className="text-lg font-bold text-gray-800">Assistant IA</h2>
            <button
              onClick={() => setIsChatOpen(false)}
              className="p-1 rounded-full text-gray-500 hover:bg-gray-200 hover:text-gray-800 focus:outline-none focus:ring-2 focus:ring-green-500"
              aria-label="Fermer le chat"
            >
              <XMarkIcon className="w-6 h-6" />
            </button>
          </div>
          <div className="flex-grow overflow-hidden">
            <AssistantIA />
          </div>
        </div>
      </div>

      {/* Bouton d'action flottant (FAB) */}
      {!isChatOpen && (
        <button
          id="chat-fab"
          onClick={() => setIsChatOpen(true)}
          className="fixed bottom-8 right-8 w-16 h-16 text-white rounded-full shadow-lg flex items-center justify-center transition-all transform hover:scale-110 z-40 focus:outline-none focus:ring-2 focus:ring-offset-2"
          style={{background: 'linear-gradient(135deg, var(--teal-400) 0%, var(--blue-400) 100%)', boxShadow: '0 4px 16px rgba(0, 188, 170, 0.3)'}}
          aria-label="Ouvrir le Assistant IA"
        >
          <RobotIcon className="w-8 h-8" />
        </button>
      )}

      {/* Tour guidé */}
      <GuidedTour
        isActive={guidedTour.isActive}
        tourType={guidedTour.tourType}
        onComplete={handleCompleteTour}
        onSkip={handleSkipTour}
      />

      {/* Assistant Contextuel - Désactivé */}
      {/* <ContextualAssistant
        currentPage="home"
        onOpenChat={handleOpenChat}
      /> */}

      {/* Popup de Guidance */}
      <GuidancePopup
        isVisible={showGuidancePopup}
        onClose={handleCloseGuidancePopup}
        onSelectProductSimulation={handleStartProductSimulation}
        onSelectStrategySimulation={handleStartStrategySimulation}
        onSelectNeedsAnalysis={handleStartNeedsAnalysis}
      />
    </div>
  );
}

export default App;